import React from 'react';

const ConstructionHeader = () => {
  return (
    <header className="w-full py-8 flex justify-center bg-amber-50">
      <div className="max-w-4xl w-full px-4 flex flex-col items-center gap-6">
        <img 
          src="https://4tsix0yujj.ufs.sh/f/2vMRHqOYUHc0vOT6nZyKJs9OrpDUz2LHG6YaodyTFNfcmRut" 
          alt="Café Tarapacá Logo" 
          className="h-24 object-contain"
        />
        <h1 className="text-4xl font-bold text-center text-amber-900">Café Tarapacá</h1>
        <div className="w-24 h-1 bg-amber-700 rounded-full"></div>
        <p className="text-xl text-center text-amber-800 leading-tight">
          Sitio en Construcción<br />
          <span className="text-lg text-amber-700">Pronto el Mejor Catálogo de Café Juan Valdez</span>
        </p>
        <video 
          className="w-full max-w-md rounded-lg shadow-lg mt-4" 
          autoPlay 
          loop 
          muted 
          playsInline
          src="https://www.juanvaldez.cl/cdn/shop/videos/c/vp/f29e0b3d4bd54193b222abc42587b066/f29e0b3d4bd54193b222abc42587b066.HD-1080p-7.2Mbps-33572593.mp4?v=0"
        >
          Tu navegador no soporta el tag de video.
        </video>
      </div>
    </header>
  );
};

export default ConstructionHeader;